// Sources reviewed on 2026-09-17: original Blogspot CV and LinkedIn certifications.
// Original titles are retained for matching credentials; visible titles are translated.
export type Certificate = { id: string; title: string; originalTitle: string; issuer: string; date: string | null; sortDate: string; category: string; credentialId: string | null; credentialUrl: string | null; source: string; image: string | null; note: string | null };
export const certificates: Certificate[] = [
  {
    "id": "certificate-1",
    "title": "AI Mission: Intelligent Automation in 4 Days",
    "originalTitle": "Missão IA: Domine Automações Inteligentes em 4 Dias - Inteligência Artificial",
    "issuer": "Rocketseat",
    "date": "Jul 2025",
    "sortDate": "2025-07",
    "category": "AI & automation",
    "credentialId": "61684cf5-baa3-444e-aef5-31376399f14c",
    "credentialUrl": "https://app.rocketseat.com.br/certificates/61684cf5-baa3-444e-aef5-31376399f14c",
    "source": "LinkedIn",
    "image": null,
    "note": null
  },
  {
    "id": "certificate-2",
    "title": "NLW Connect — C#",
    "originalTitle": "NLW Connect - Csharp",
    "issuer": "Rocketseat",
    "date": "Feb 2025",
    "sortDate": "2025-02",
    "category": "Web & backend",
    "credentialId": "af012359-f3b8-4c76-b039-0cfb312e35cc",
    "credentialUrl": "https://app.rocketseat.com.br/certificates/af012359-f3b8-4c76-b039-0cfb312e35cc",
    "source": "LinkedIn",
    "image": null,
    "note": null
  },
  {
    "id": "certificate-3",
    "title": "NLW Pocket — JavaScript Full Stack (Intermediate)",
    "originalTitle": "NLW Pocket: Javascript - Full-stack Intermediário",
    "issuer": "Rocketseat",
    "date": "Sep 2024",
    "sortDate": "2024-09",
    "category": "Web & backend",
    "credentialId": "1ecbb604-a0a3-49c0-b5ed-583cd22a3f28",
    "credentialUrl": "https://app.rocketseat.com.br/certificates/1ecbb604-a0a3-49c0-b5ed-583cd22a3f28",
    "source": "LinkedIn",
    "image": null,
    "note": null
  },
  {
    "id": "certificate-4",
    "title": "ReactJS — 50-hour Programme",
    "originalTitle": "Certificado Final - ReactJS - 50h",
    "issuer": "Rocketseat",
    "date": "Aug 2024",
    "sortDate": "2024-08",
    "category": "Web & backend",
    "credentialId": "c954e88e-a1b7-48e1-80df-9df3ab8a807d",
    "credentialUrl": "https://app.rocketseat.com.br/certificates/c954e88e-a1b7-48e1-80df-9df3ab8a807d",
    "source": "LinkedIn",
    "image": null,
    "note": null
  },
  {
    "id": "certificate-5",
    "title": "C# Backend — 100-hour Programme",
    "originalTitle": "Certificado final - C# Backend 100h",
    "issuer": "Rocketseat",
    "date": "Aug 2024",
    "sortDate": "2024-08",
    "category": "Web & backend",
    "credentialId": "33125e99-c910-4da4-ba68-526a81807fd7",
    "credentialUrl": "https://app.rocketseat.com.br/certificates/33125e99-c910-4da4-ba68-526a81807fd7",
    "source": "LinkedIn",
    "image": null,
    "note": null
  },
  {
    "id": "certificate-6",
    "title": "NLW Journey — C#",
    "originalTitle": "NLW Journey - Csharp",
    "issuer": "Rocketseat",
    "date": "Jul 2024",
    "sortDate": "2024-07",
    "category": "Web & backend",
    "credentialId": "955cac59-94a7-4646-b9ee-5ef8b14b987d",
    "credentialUrl": "https://app.rocketseat.com.br/certificates/955cac59-94a7-4646-b9ee-5ef8b14b987d",
    "source": "LinkedIn",
    "image": null,
    "note": null
  },
  {
    "id": "certificate-7",
    "title": "Essential Blazor (including .NET 8)",
    "originalTitle": "Curso Blazor Essencial (inclui Blazor no NET 8.0)",
    "issuer": "Udemy",
    "date": "Jun 2024",
    "sortDate": "2024-06",
    "category": "Web & backend",
    "credentialId": "UC-be453f08-6c90-4445-8b9a-6aae61b709e6",
    "credentialUrl": "https://www.udemy.com/certificate/UC-be453f08-6c90-4445-8b9a-6aae61b709e6/",
    "source": "LinkedIn",
    "image": null,
    "note": null
  },
  {
    "id": "react-complete",
    "title": "React — The Complete Guide 2024 (Next.js & Redux)",
    "originalTitle": "React — The Complete Guide 2024 (Next.js & Redux)",
    "issuer": "Udemy",
    "date": "Jun 2024",
    "sortDate": "2024-06",
    "category": "Web & backend",
    "credentialId": "UC-9f2517d9-a24b-4149-93b7-2cf2b1a3ba7e",
    "credentialUrl": "https://www.udemy.com/certificate/UC-9f2517d9-a24b-4149-93b7-2cf2b1a3ba7e/",
    "source": "Original CV",
    "image": "/certificates/react-complete.webp",
    "note": null
  },
  {
    "id": "php7",
    "title": "Complete PHP 7 Course",
    "originalTitle": "Complete PHP 7 Course",
    "issuer": "Udemy",
    "date": "Jun 2024",
    "sortDate": "2024-06",
    "category": "Web & backend",
    "credentialId": "UC-ceb7bdbb-4db8-4fe7-9d5f-b39ae2def585",
    "credentialUrl": "https://www.udemy.com/certificate/UC-ceb7bdbb-4db8-4fe7-9d5f-b39ae2def585/",
    "source": "Original CV",
    "image": "/certificates/php7.webp",
    "note": null
  },
  {
    "id": "certificate-8",
    "title": "NLW Expert — C# and .NET",
    "originalTitle": "NLW Expert trilha de C",
    "issuer": "Rocketseat",
    "date": "Feb 2024",
    "sortDate": "2024-02",
    "category": "Web & backend",
    "credentialId": "d0e2c4f2-f152-4dc9-966e-d7526fc8b111",
    "credentialUrl": "https://app.rocketseat.com.br/certificates/d0e2c4f2-f152-4dc9-966e-d7526fc8b111",
    "source": "LinkedIn & original CV",
    "image": "/certificates/nlw-expert.webp",
    "note": null
  },
  {
    "id": "certificate-9",
    "title": "Craft an Inventory System with Godot 4",
    "originalTitle": "Craft an Inventory System with Godot 4",
    "issuer": "Zenva",
    "date": "Dec 2023",
    "sortDate": "2023-12",
    "category": "Game development",
    "credentialId": "98a055843800",
    "credentialUrl": "https://academy.zenva.com/certificate/98a055843800",
    "source": "LinkedIn",
    "image": null,
    "note": null
  },
  {
    "id": "certificate-10",
    "title": "Real-Time Strategy Game with Godot 4",
    "originalTitle": "Real-Time Strategy Game with Godot 4",
    "issuer": "Zenva",
    "date": "Dec 2023",
    "sortDate": "2023-12",
    "category": "Game development",
    "credentialId": "75b1d55bb47b",
    "credentialUrl": "https://academy.zenva.com/certificate/75b1d55bb47b",
    "source": "LinkedIn",
    "image": null,
    "note": null
  },
  {
    "id": "certificate-11",
    "title": "Make an AI State Machine in Godot 4",
    "originalTitle": "Make an AI State Machine in Godot 4",
    "issuer": "Zenva",
    "date": "Dec 2023",
    "sortDate": "2023-12",
    "category": "Game development",
    "credentialId": "910ac97116bd",
    "credentialUrl": "https://academy.zenva.com/certificate/910ac97116bd",
    "source": "LinkedIn",
    "image": null,
    "note": null
  },
  {
    "id": "certificate-12",
    "title": "Build a Walking Simulator with Godot 4",
    "originalTitle": "Build a Walking Simulator with Godot 4",
    "issuer": "Zenva",
    "date": "Dec 2023",
    "sortDate": "2023-12",
    "category": "Game development",
    "credentialId": "c76edd419949",
    "credentialUrl": "https://academy.zenva.com/certificate/c76edd419949",
    "source": "LinkedIn",
    "image": null,
    "note": null
  },
  {
    "id": "certificate-13",
    "title": "Essential ASP.NET Core Web API (.NET 6)",
    "originalTitle": "Curso Web API ASP .NET Core Essencial (.NET 6)",
    "issuer": "Udemy",
    "date": "Nov 2023",
    "sortDate": "2023-11",
    "category": "Web & backend",
    "credentialId": "UC-b0d4af94-b06b-4a4c-ba39-0713bcd2f963",
    "credentialUrl": "https://www.udemy.com/certificate/UC-b0d4af94-b06b-4a4c-ba39-0713bcd2f963/",
    "source": "LinkedIn & original CV",
    "image": "/certificates/aspnet-web-api.webp",
    "note": null
  },
  {
    "id": "certificate-14",
    "title": "AI Prompt Engineering for Game Developers",
    "originalTitle": "AI Prompt Engineering for Game Developers",
    "issuer": "Zenva",
    "date": "Sep 2023",
    "sortDate": "2023-09",
    "category": "Game development",
    "credentialId": "fb9e9a779421",
    "credentialUrl": "https://academy.zenva.com/certificate/fb9e9a779421",
    "source": "LinkedIn",
    "image": null,
    "note": "Expiry listed on LinkedIn: September 2033."
  },
  {
    "id": "certificate-15",
    "title": "Explore Micro-Survival Games with Godot 4",
    "originalTitle": "Explore Micro-Survival Games with Godot 4",
    "issuer": "Zenva",
    "date": "Sep 2023",
    "sortDate": "2023-09",
    "category": "Game development",
    "credentialId": "88b6ab3a84d6",
    "credentialUrl": "https://academy.zenva.com/certificate/88b6ab3a84d6",
    "source": "LinkedIn",
    "image": null,
    "note": "LinkedIn lists this completion record as expired in September 2023."
  },
  {
    "id": "certificate-16",
    "title": "Build a Micro Turn-Based RPG with Godot 4",
    "originalTitle": "Build a Micro Turn-Based RPG with Godot 4",
    "issuer": "Zenva",
    "date": "May 2023",
    "sortDate": "2023-05",
    "category": "Game development",
    "credentialId": "b9ecb37b5983",
    "credentialUrl": "https://academy.zenva.com/certificate/b9ecb37b5983",
    "source": "LinkedIn",
    "image": null,
    "note": null
  },
  {
    "id": "certificate-17",
    "title": "Intro to Game Design",
    "originalTitle": "Intro to Game Design",
    "issuer": "Zenva",
    "date": "May 2023",
    "sortDate": "2023-05",
    "category": "Game development",
    "credentialId": "1d5a8857a6cb",
    "credentialUrl": "https://academy.zenva.com/certificate/1d5a8857a6cb",
    "source": "LinkedIn",
    "image": null,
    "note": null
  },
  {
    "id": "certificate-18",
    "title": "Develop a 3D Platformer with Godot 4",
    "originalTitle": "Develop a 3D Platformer with Godot 4",
    "issuer": "Zenva",
    "date": "May 2023",
    "sortDate": "2023-05",
    "category": "Game development",
    "credentialId": "3ddf1a9392fd",
    "credentialUrl": "https://academy.zenva.com/certificate/3ddf1a9392fd",
    "source": "LinkedIn",
    "image": null,
    "note": null
  },
  {
    "id": "certificate-19",
    "title": "Create a 2D Platformer with Godot 4",
    "originalTitle": "Create a 2D Platformer with Godot 4",
    "issuer": "Zenva",
    "date": "May 2023",
    "sortDate": "2023-05",
    "category": "Game development",
    "credentialId": "1764876f8d11",
    "credentialUrl": "https://academy.zenva.com/certificate/1764876f8d11",
    "source": "LinkedIn",
    "image": null,
    "note": null
  },
  {
    "id": "certificate-20",
    "title": "Godot 4 Mini-Projects",
    "originalTitle": "Godot 4 Mini-Projects",
    "issuer": "Zenva",
    "date": "May 2023",
    "sortDate": "2023-05",
    "category": "Game development",
    "credentialId": "d64e6df5e392",
    "credentialUrl": "https://academy.zenva.com/certificate/d64e6df5e392",
    "source": "LinkedIn",
    "image": null,
    "note": null
  },
  {
    "id": "certificate-21",
    "title": "Intro to Godot 4 Game Development",
    "originalTitle": "Intro to Godot 4 Game Development",
    "issuer": "Zenva",
    "date": null,
    "sortDate": "2023-05",
    "category": "Game development",
    "credentialId": "b9cfbb49b098",
    "credentialUrl": "https://academy.zenva.com/certificate/b9cfbb49b098",
    "source": "LinkedIn",
    "image": null,
    "note": "The issue date on LinkedIn is May 2013 and needs confirmation."
  },
  {
    "id": "certificate-22",
    "title": "Use pages, routing, and layouts to improve navigation in Blazor",
    "originalTitle": "Use pages, routing, and layouts to improve navigation in Blazor",
    "issuer": "Microsoft",
    "date": "Apr 2023",
    "sortDate": "2023-04",
    "category": "Web & backend",
    "credentialId": null,
    "credentialUrl": "https://learn.microsoft.com/pt-br/training/achievements/learn.use-pages-routing-layouts-improve-blazor-navigation.badge?username=NunoMiranda-9282&sharingId=2B0DDAA63C0AE6DF",
    "source": "LinkedIn",
    "image": null,
    "note": null
  },
  {
    "id": "certificate-23",
    "title": "Getting Started with .NET on AWS",
    "originalTitle": "AWS - SDK for DotNet / Getting Started with .NET on AWS",
    "issuer": "Amazon Web Services (AWS)",
    "date": "Jan 2023",
    "sortDate": "2023-01",
    "category": "Cloud",
    "credentialId": "ID: E-XVDGPV\"",
    "credentialUrl": "https://nuno-miranda.notion.site/AWS-Certificates-0fda140340824691a3afff603edc8841",
    "source": "LinkedIn & original CV",
    "image": "/certificates/aws-dotnet.webp",
    "note": null
  },
  {
    "id": "ignite-node",
    "title": "Ignite — Node.js (100 hours)",
    "originalTitle": "Ignite — Node.js (100 hours)",
    "issuer": "Rocketseat",
    "date": "Dec 2022",
    "sortDate": "2022-12",
    "category": "Web & backend",
    "credentialId": null,
    "credentialUrl": null,
    "source": "Original CV",
    "image": "/certificates/ignite-node.webp",
    "note": null
  },
  {
    "id": "certificate-24",
    "title": "Godot 3D Engine - Puzzle Game",
    "originalTitle": "Godot 3D Engine - Puzzle Game",
    "issuer": "Canopy Games",
    "date": "Mar 2022",
    "sortDate": "2022-03",
    "category": "Game development",
    "credentialId": null,
    "credentialUrl": "https://snapdragon-room-4e0.notion.site/Godot-3D-Engine-Puzzle-Game-4fa5f1fbd808413293e464bd9dbdc0af",
    "source": "LinkedIn",
    "image": null,
    "note": null
  },
  {
    "id": "node-complete",
    "title": "The Complete Node.js Developer Course (3rd Edition)",
    "originalTitle": "The Complete Node.js Developer Course (3rd Edition)",
    "issuer": "Udemy",
    "date": "Jan 2021",
    "sortDate": "2021-01",
    "category": "Web & backend",
    "credentialId": null,
    "credentialUrl": null,
    "source": "Original CV",
    "image": "/certificates/node-complete.webp",
    "note": null
  },
  {
    "id": "web-development",
    "title": "Web Development — Build 6 Projects",
    "originalTitle": "Web Development — Build 6 Projects",
    "issuer": "Udemy",
    "date": "Aug 2019",
    "sortDate": "2019-08",
    "category": "Web & backend",
    "credentialId": null,
    "credentialUrl": null,
    "source": "Original CV",
    "image": "/certificates/web-development.webp",
    "note": null
  },
  {
    "id": "csharp-basics",
    "title": "C# Programming Fundamentals",
    "originalTitle": "C# Programming Fundamentals",
    "issuer": "AprendaUnity",
    "date": "Mar 2016",
    "sortDate": "2016-03",
    "category": "Game development",
    "credentialId": null,
    "credentialUrl": null,
    "source": "Original CV",
    "image": "/certificates/csharp-basics.webp",
    "note": null
  },
  {
    "id": "crossy-road",
    "title": "Crossy Road",
    "originalTitle": "Crossy Road",
    "issuer": "AprendaUnity",
    "date": "Mar 2016",
    "sortDate": "2016-03",
    "category": "Game development",
    "credentialId": null,
    "credentialUrl": null,
    "source": "Original CV",
    "image": "/certificates/crossy-road.webp",
    "note": null
  }
];
